import React from "react";

const RecordCard = ({ record, onClick }) => {
    const coverSrc =
        record.cover && (record.cover.startsWith("http://") || record.cover.startsWith("https://"))
            ? record.cover
            : `https://rjbogz.com/records/${record.cover}`;

    return (
        <div className="card" onClick={onClick}>
            <img
                src={coverSrc}
                alt={`${record.artist} - ${record.album}`}
            />
            <p>{`${record.artist} - ${record.album}`}</p>
        </div>
    );
};

export default RecordCard;